export default __webpack_public_path__ + "static/onboarding-consultants-integrating-lms-salesforce-76579e7f23c2f0aa996fe525ace388a7.jpg";